var React = require('react');

function Incomplete (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M9 0v9L1.206 4.5q.095-.164.192-.32A9 9 0 1 0 9 0"}));
}

Incomplete.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Incomplete;

Incomplete.default = Incomplete;
